import React from 'react';

import { Button } from '@mokoboko/components';
import {
  generateGoogleCalendarUrl,
  downloadICalFile,
  mergeClassNames,
} from '@/lib/utils';
import { CalendarSchedulerIcon, GoogleCalendarIcon } from '@/icons';
import { track, AnalyticsEvent } from '@/lib/analytics/tracker';

interface CalendarIntegrationProps {
  title: string;
  description?: string;
  location?: string | null;
  startTime: Date;
  endTime: Date;
  // The server's calendar file. Without one the file is built here.
  icsUrl?: string | null;
  className?: string;
}

export const CalendarIntegration = ({
  title,
  description,
  location,
  startTime,
  endTime,
  icsUrl,
  className = '',
}: CalendarIntegrationProps) => {
  const handleGoogleCalendar = () => {
    const url = generateGoogleCalendarUrl({
      title,
      description,
      location: location || '',
      startTime,
      endTime,
    });
    window.open(url, '_blank');
    track({
      event: AnalyticsEvent.CALENDAR_DOWNLOAD_CLICKED,
      properties: { calendar_type: 'google' },
    });
  };

  const handleICalDownload = () => {
    if (icsUrl) {
      window.location.assign(icsUrl);
    } else {
      downloadICalFile({
        title,
        description,
        location: location || '',
        startTime,
        endTime,
      });
    }
    track({
      event: AnalyticsEvent.CALENDAR_DOWNLOAD_CLICKED,
      properties: { calendar_type: 'ics' },
    });
  };

  return (
    <div className={mergeClassNames('flex w-full gap-4', className)}>
      <Button
        variant="secondary-gray"
        size="lg"
        className="flex-1 justify-center"
        leadingIcon={<CalendarSchedulerIcon />}
        onClick={handleICalDownload}
      >
        iCal/Outlook
      </Button>
      <Button
        variant="secondary-gray"
        size="lg"
        className="flex-1 justify-center"
        leadingIcon={<GoogleCalendarIcon />}
        onClick={handleGoogleCalendar}
      >
        Google
      </Button>
    </div>
  );
};
